import * as React from 'react';

import {NavItemData} from '../../interfaces';
import {MegaNavItem} from '..';
import styles from './NavDrawerItem.scss';

interface NavDrawerItemProps {
  item: NavItemData;
  tabIndex: number;
  tracking?: any;
}

export function NavDrawerItem(props: NavDrawerItemProps) {
  const {
    item,
    tabIndex,
    tracking = {},
  } = props;

  return (
    <li className={styles.navDrawerItem}>
      <MegaNavItem item={item} tabIndex={tabIndex} {...tracking} />
    </li>
  );
}

export default NavDrawerItem;
